<template>
  <div class='bannerTab mainWrapper'>
    <VHeader :toList='ToList' :from='fromTabs'></VHeader>
    <div class="contentBody" :class="{'suitIOS':!ISANDROID}" ref="tabRef">
      <div class="tabContent">
        <div v-for="(item, index) in tabsArray" :key="index" class="tabItem" @click="goToDetail(item)">
          <div class="time">{{item.startTime}}</div>
          <div class="tab">
            <img class="bgImg" :src="item.adPhoto" alt="">
            <div class="tabTitle">
              <p>{{item.adTitle}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VHeader from '@/components/VHeader'
  import { tabsInfoUrl } from '@/tools/address'
  import axios from 'axios'
  import BScroll from 'better-scroll'
  import { getUserInfo } from '@/tools/isAndroid';
  export default {
    name: 'BannerTabs',
    data() {
      return {
        ToList: false,
        requestUrl: tabsInfoUrl,
        tabsArray: [],
        fromTabs: 'tabs'
      }
    },
    mounted() {
      this.getData();
    },
    methods: {
      goToDetail(item) {
        this.$store.commit('changeDirection', true);
        this.$router.push({
          path: '/detail',
          query: {
            id: item.id,
            from: 'banner'
          }
        })
        this.$store.commit('addRouter');
      },
      getData() {
        let userInfos = getUserInfo();
        axios.get(this.requestUrl, {
          params: {
            appType: '0',
            userId: userInfos.userId,
            sessionId: userInfos.sessionId,
            casCookie: userInfos.casCookie
          }
        })
          .then((res) => {
            if (res.status == 200 && !res.data.errorCode) {
              // console.log(res.data);
              if (res.data.data.length > 0) {
                // this.tabsArray = res.data.data;
                res.data.data.forEach((singleItem, index) => {
                  if (!singleItem.isExtraLink) {
                    this.tabsArray.push(singleItem)
                  }
                })
              }
            }
            this._initialScroll();
          })
      },
      _initialScroll() {
        if (!this.scroll) {
          this.mainWrapper = new BScroll(this.$refs.tabRef, {
            click: true
          });
        } else {
          this.scroll.refresh();
        }
      }
    },
    components: {
      VHeader
    }
  }
</script>

<style lang='scss' scoped>
  @import "@/assets/scss/_mixin.scss";

  .bannerTab {
    position: relative;
    background: rgba(249, 250, 252, 1);

    .contentBody {
      left: 0px;
      right: 0px;
      padding: 0 0.32rem;
      overflow: hidden;

      .tabContent {
        width: 100%;

        .tabItem {
          .time {
            font-size: 9px;
            font-family: MicrosoftYaHei;
            color: rgba(153, 153, 153, 1);
            text-align: center;
            padding: pxToRem(16) 0 pxToRem(16) 0;
          }

          .tab {
            width: 100%;
            height: pxToRem(195);
            background: red;
            border-radius: 5px;
            position: relative;
            overflow: hidden;
            background: rgba(0, 0, 0, 0.1);

            .tabTitle {
              position: absolute;
              bottom: pxToRem(10);
              box-sizing: border-box;
              padding: 0 pxToRem(18) 0 pxToRem(17);
              font-size: 15px;
              font-family: MicrosoftYaHei;
              color: rgba(255, 255, 255, 1);
              line-height: 26px;
            }

            .bgImg {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/BannerTabs.vue